import { Container, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { StyledButton, getTransitionStyle } from '../Utils/UIUtils';
import { CheckRounded, ArrowForward } from '@mui/icons-material';

export default function FreeTrial() {
  const { t } = useTranslation();
  const theme = useTheme();
  const arrowTransitionStyle = getTransitionStyle(theme, ['transform']);
  return (
    <Container maxWidth="lg">
      <Stack
        justifyContent={'center'}
        alignItems={'center'}
        gap={2}
        sx={{
          p: 4,
          textAlign: 'center',
        }}
      >
        <Stack gap={2} sx={{ width: { xs: '100%', md: '50%' } }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: '32px',
              fontWeight: '700',
              color: 'primary.neutral800',
            }}
          >
            {t('HOME_PAGE.FREE_TRIAL.TITLE')}
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: '16px', color: 'text.secondary' }}
          >
            {t('HOME_PAGE.FREE_TRIAL.DESCRIPTION')}
          </Typography>
        </Stack>
        <StyledButton
          variant="contained"
          href="/free-trial"
          sx={{
            alignSelf: 'center',
            bgcolor: 'primary.main',
            color: 'white',
            p: '12px 24px',
            fontWeight: '400',
            fontSize: '15px',
            '&:hover .MuiButton-endIcon ': {
              transform: 'translateX(4px)',
              ...arrowTransitionStyle,
            },
            '& .MuiButton-endIcon': {
              ...arrowTransitionStyle,
            },
          }}
          endIcon={<ArrowForward />}
        >
          {t('HOME_PAGE.FREE_TRIAL.BUTTON')}
        </StyledButton>
        <Stack direction={'row'} alignItems={'flex-start'} gap={1}>
          <CheckRounded
            sx={{
              fontSize: '20px',
              color: 'primary.main',
              backgroundColor: 'primary.primarylight1',
              borderRadius: '50%',
              p: 0.4,
            }}
          />
          <Typography
            variant="body1"
            sx={{ fontSize: '14px', textAlign: 'left' }}
          >
            {t('HOME_PAGE.FREE_TRIAL.NO_CREDIT_CARD')}
          </Typography>
        </Stack>
      </Stack>
    </Container>
  );
}
